import React from "react";
import { useThemeUI } from "theme-ui";

export default function useThemeColor(color) {
  const { theme } = useThemeUI();
  return theme.rawColors[color] || color;
}
